import React from 'react';
import { BarChart3Icon, BrainCircuitIcon, FacebookIcon } from 'lucide-react';
const features = [{
  icon: <BrainCircuitIcon size={32} className="text-black" data-id="element-64" />,
  title: 'AI-Powered Analysis',
  description: 'Our advanced AI algorithms analyze your Facebook ads to identify performance patterns and improvement opportunities.'
}, {
  icon: <FacebookIcon size={32} className="text-black" data-id="element-65" />,
  title: 'Automated Posting',
  description: 'Schedule and automate your Facebook ad campaigns with intelligent timing based on audience engagement metrics.'
}, {
  icon: <BarChart3Icon size={32} className="text-black" data-id="element-66" />,
  title: 'Performance Tracking',
  description: 'Track key metrics and receive detailed reports on your ad performance with actionable insights.'
}];
const FeaturesSection = () => {
  return <section className="py-20 md:py-32 bg-gray-50 px-4 md:px-6" data-id="element-67">
      <div className="container mx-auto max-w-6xl" data-id="element-68">
        <div className="text-center mb-16 md:mb-24" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-light mb-6 tracking-tight" data-id="element-70">
            Key Features
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-71">
            Optimize your Facebook advertising strategy with our powerful AI
            tools
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-72">
          {features.map((feature, index) => <div key={index} className="bg-white p-8 md:p-10 rounded-sm transition-all duration-300 hover:shadow-lg" data-id="element-73">
              <div className="mb-6" data-id="element-74">{feature.icon}</div>
              <h3 className="text-xl font-medium mb-4 tracking-tight" data-id="element-75">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-76">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default FeaturesSection;